// Copyright (c) 2020 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";

import { IAction } from "actions";
import { IState } from "states/states";

import IconSearch from "icons/iconSearch";
import IconClearSearch from "icons/iconZoomFit";

interface ISearchFilterExtProps {
  className?: string;
  filterText: string;
  onChange: (searchText: string) => void;
  placeholder: string;
  tooltip?: string;
  datalist?: string;
  autoFocus?: boolean;
  id?: string;
  tabIndex?: number;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  // report changes only once typing paused; filterText then just sets the initial text
  debounceMs?: number;
}

interface ISearchFilterState {
  // input text while debouncing
  text: string;
}

interface ISearchFilterProps {}

const mapStateToProps = (state: IState, ownProps: ISearchFilterExtProps) => {
  const props: ISearchFilterProps = {};
  return props;
};

interface ISearchFilterDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: ISearchFilterDispatch = {};
  return dispatchProps;
};

class SearchFilterComponent extends React.Component<
  ISearchFilterProps & ISearchFilterExtProps & ISearchFilterDispatch,
  ISearchFilterState
> {
  state: ISearchFilterState = { text: this.props.filterText };

  private debounceTimeout?: number;

  componentWillUnmount() {
    window.clearTimeout(this.debounceTimeout);
  }

  private handleChange = (text: string) => {
    if (!this.props.debounceMs) {
      this.props.onChange(text);
      return;
    }
    this.setState({ text });
    window.clearTimeout(this.debounceTimeout);
    this.debounceTimeout = window.setTimeout(
      () => this.props.onChange(text),
      this.props.debounceMs,
    );
  };

  public render() {
    const filterText = this.props.debounceMs ? this.state.text : this.props.filterText;
    return (
      <div className={"listSearchBox " + (this.props.className ?? "")}>
        <input
          id={this.props.id}
          tabIndex={this.props.tabIndex}
          title={this.props.tooltip}
          placeholder={this.props.placeholder}
          value={filterText}
          autoFocus={this.props.autoFocus}
          onChange={(event) => this.handleChange(event?.currentTarget.value ?? "")}
          onKeyDown={this.props.onKeyDown}
          type="text"
          list={this.props.datalist}
        />
        {filterText !== "" ?
          <IconClearSearch
            className="searchIcon clearable"
            width={"30px"}
            height={"30px"}
            fill="red"
            tabIndex={0}
            role="button"
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                this.handleChange("");
              }
            }}
            onClick={() => this.handleChange("")}
          />
        : <IconSearch className="searchIcon" width={"30px"} height={"30px"} viewBox={"5 0 35 50"} />
        }
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchFilterComponent);
